export default "__VITE_ASSET__dad239a9__"